import APP_CONFIG from '../config/appConfig';

const API_BASE_URL = APP_CONFIG.API.BASE_URL;

class PasswordResetApiService {
    constructor() {
        this.baseURL = API_BASE_URL;
    }

    /**
     * Initiate password reset
     * @param {string} email - User's email address
     * @returns {Promise<Object>} Response with success/error message
     */
    async forgotPassword(email) {
        try {
            const response = await fetch(`${this.baseURL}/auth/forgot-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Failed to send password reset email');
            }

            return data;
        } catch (error) {
            console.error('Forgot password error:', error);
            throw error;
        }
    }

    /**
     * Reset password using token
     * @param {string} token - Reset token from email
     * @param {string} newPassword - New password
     * @returns {Promise<Object>} Response with success/error message
     */
    async resetPassword(token, newPassword) {
        try {
            const response = await fetch(`${this.baseURL}/auth/reset-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ token, newPassword }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Failed to reset password');
            }

            return data;
        } catch (error) {
            console.error('Reset password error:', error);
            throw error;
        }
    }

    /**
     * Validate reset token
     * @param {string} token - Reset token to validate
     * @returns {Promise<Object>} Response with validity status
     */
    async validateResetToken(token) {
        try {
            const response = await fetch(`${this.baseURL}/auth/validate-reset-token?token=${encodeURIComponent(token)}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            const data = await response.json();

            return {
                isValid: response.ok && data.success,
                message: data.message
            };
        } catch (error) {
            console.error('Token validation error:', error);
            return {
                isValid: false,
                message: 'Failed to validate token'
            };
        }
    }
}

export default new PasswordResetApiService();